var scrollers = document.querySelectorAll(".scroller");

if (scrollers.length > 0) {
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    addAnimation();
  }

  function addAnimation() {
    scrollers.forEach((scroller) => {
      scroller.setAttribute("data-animated", true);

      var scrollerInner = scroller.querySelector(".scroller__inner");
      var scrollerContent = Array.from(scrollerInner.children);

      scrollerContent.forEach((item) => {
        var duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute("aria-hidden", true);
        scrollerInner.appendChild(duplicatedItem);
      });
    });
  }
}
